/*
 *  Add To Cart Button
 *    Contains scripts for add to cart button for product templates
 *
 *  Version:
 *    1.0.0 - 2020/03/04
 */

import { addToCart, ON_CART_PENDING, ON_CART_FINISHED, getCountOfVariantInCart } from './../../process/pc-slate-tools';
import { ON_VARIANT_CHANGE } from './../variant/VariantSelector';
import { generateLoader } from './../loader/Loader';

export const ADD_BUTTON = '[data-add-to-cart-button]';
export const ADD_NOTIFICATION = '[data-add-to-cart-notification]';

export const EXTRA_INFO = '[data-product-extra-info]';

export const CLASS_DISABLED = 'is-disabled';
export const CLASS_SUCCESS = 'is-success';
export const CLASS_HIDDEN = 'is-hidden';

export class AddToCartButton {
  constructor(template, container) {
    this.template = template;
    this.container = container;
    this.cartPending = false;

    //Elements
    this.button = container.find(ADD_BUTTON);
    this.notification = container.find(ADD_NOTIFICATION);
    this.extraInfo = $(EXTRA_INFO);

    $(document).on(ON_VARIANT_CHANGE, (e,variant) => this.useVariant(variant));
    container.on('click', ADD_BUTTON, (e) => this.onAddClick(e));

    this.useVariant(this.getVariantData());
  }

  getVariantData() {
    let vs = (this.template.swatches || this.template.variantSelector);
    return vs.getVariantData();
  }

  updateButton(variant, id) {
    //Adjust the add to cart button based on QTY available and in cart
    let { available, inventory_policy, inventory_management, inventory_quantity } = variant;
    let inCart = getCountOfVariantInCart(id);

    this.button.removeClass(CLASS_SUCCESS);

    if (available) {
      this.button.removeClass(CLASS_HIDDEN);

      if (inventory_policy == 'continue') {

        // Product is on preorder
        if ((inventory_quantity - inCart) <= 0) {
          this.button.html(`${Language.strings['products.product.on_preorder']}`);
          this.button.removeAttr('disabled', 'disabled');
          this.button.removeClass(CLASS_DISABLED);
        }

        // Product is in stock
        else {
          this.button.html(`${Language.strings['products.product.add_to_cart']}`);
          this.button.removeAttr('disabled', 'disabled');
          this.button.removeClass(CLASS_DISABLED);
        }

      } else {

        // Bag is full
        if ((inventory_quantity - inCart) <= 0) {
          available = false;
          this.button.html(`${Language.strings['products.product.all_in_cart']}`);
          this.button.attr('disabled', 'disabled');
          this.button.addClass(CLASS_DISABLED);
        }

        // Product is in stock
        else {
          this.button.html(`${Language.strings['products.product.add_to_cart']}`);
          this.button.removeAttr('disabled', 'disabled');
          this.button.removeClass(CLASS_DISABLED);
        }

      }

    } else {
      this.button.html(`${Language.strings['products.product.sold_out']}`);
      this.button.attr('disabled', 'disabled');
      this.button.addClass(CLASS_DISABLED);
      this.button.addClass(CLASS_HIDDEN);
    }

  }

  useVariant(variant) {

    // Update extra product info on variant change
    let isPreorder = variant.inventory_policy == 'continue' && variant.inventory_quantity <= 0;
    let isIncomingStock = false;
    if ('product' in variant && 'tags' in variant.product) {
      isIncomingStock = variant.product.tags.includes('Incoming Stock');
    }

    if (isPreorder && variant.preorder_message) {
      this.extraInfo.text(variant.preorder_message);
      this.extraInfo.removeClass(CLASS_HIDDEN);
    } else if (isIncomingStock && variant.incoming_stock_message) {
      this.extraInfo.text(variant.incoming_stock_message);
      this.extraInfo.removeClass(CLASS_HIDDEN);
    }
    else {
      this.extraInfo.addClass(CLASS_HIDDEN);
      this.extraInfo.text('');
    }

    if(this.cartPending) return;//Don't update the button if the cart is pending
    let { id } = variant;
    this.updateButton(variant, id);
  }

  onCartPending() {
    this.cartPending = true;

    this.button.addClass('is-disabled');
    this.button.attr('disabled', 'disabled');
    this.button.html(generateLoader(null, null, null, 16));
  }

  onCartFinished() {
    this.cartPending = false;
    this.useVariant(this.getVariantData());
  }

  async onAddClick(e) {
    e.preventDefault();
    e.stopPropagation();
    let id = this.getVariantData().id;
    let variant = this.getVariantData(id);

    if (this.button.hasClass(CLASS_DISABLED)) return;

    // Attempt to add to cart
    try {

      this.button.html(`${Language.strings['products.product.cart_pending']}`);

      // Define preorder line items if needed
      let inCart = getCountOfVariantInCart(id);
      let lineItemProperties = {};
      let isPreorder = variant.inventory_policy == 'continue' && (variant.inventory_quantity - inCart) <= 0;
      if (isPreorder && variant.preorder_message) {
        lineItemProperties[Language.strings['products.product.preorder_property']] = Language.strings['products.product.on_preorder'];
      }

      // Add the item to cart
      await addToCart(id, this.template.quantitySelector.getValue(), lineItemProperties);
      this.wasAdded = true; // This will tell our button to temporarily display the "Was added" text

    } catch (e) {
      console.error(e);
      if(e.description) alert(e.description);
      return;
    }

    this.button.html(`${Language.strings['products.product.added_to_cart']}`);
    this.button.addClass(CLASS_SUCCESS);
    setTimeout(() => this.updateButton(variant, id), 5000);
  }
}
